import { render } from "./TheTrend.vue?vue&type=template&id=78fedfc7&scoped=true&ts=true"
import script from "./TheTrend.vue?vue&type=script&lang=ts"
export * from "./TheTrend.vue?vue&type=script&lang=ts"

import "./TheTrend.vue?vue&type=style&index=0&id=78fedfc7&scoped=true&lang=scss"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78fedfc7"]])

export default __exports__